<div class="row">
  <div class="col-md-6">
    <form #paymentEntry="ngForm" class="form-horizontal">
      <div class="card card-body">
        <div class="row">
          <app-material-date-range
            id="reportStartDatePicker"
            id="payDate"
            name="payDate"
            [singleDateSelector]="true"
            [jalali]="true"
            [disabled]="edit"
            [(dateRange)]="dateRange">
          </app-material-date-range>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="شماره فیش پرداختی"
              type="text"
              name="paymentBillNo"
              id="paymentBillNo"
              [ngModel]="payment?.paymentBillNo"
              (ngModelChange)="payment.paymentBillNo = $event"
              [disabled]="edit"
              [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            class="pg-component"
            [(ngModel)]="company"
            [organisationLanguage]="'fa'"
            name="company"
            [organisations]="companies"
            [placeholder]="'شرکت'"
            [required]="true">
          </app-material-organisation-selector>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            class="pg-component"
            [(ngModel)]="source"
            [organisationLanguage]="'fa'"
            name="source"
            [organisations]="sources"
            [placeholder]="'مبدا'"
            [required]="true">
          </app-material-organisation-selector>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="میزان خریداری شده"
              type="text"
              name="totalWeight"
              id="totalWeight"
              [ngModel]="payment?.totalWeight"
              (ngModelChange)="payment.totalWeight = $event"
              [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="قیمت هر کیلو"
              type="text"
              name="costPerKilo"
              id="costPerKilo"
              [ngModel]="payment?.costPerKilo"
              (ngModelChange)="payment.costPerKilo = $event"
              [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <app-material-pg-input
              label="مبلغ فیش واریزی"
              type="text"
              name="wholePayment"
              id="wholePayment"
              [ngModel]="payment?.wholePayment"
              (ngModelChange)="payment.wholePayment = $event"
              [required]="true">
          </app-material-pg-input>
        </div>
          <div class="form-group row">
            <label for="isDeleted" class="col-form-label col-md-4 ">
              حذف شده</label>
              <mat-checkbox
                class=" col-md-4 "
                type="checkbox"
                id="isDeleted"
                name="isDeleted"
                [ngModel]="payment?.isDeleted"
                (ngModelChange)="payment.isDeleted = $event">
              </mat-checkbox>
          </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-raised-button
              mat-stroked-button
              name="pay"
              value="Save"
              (click)="addPayment()"
              class="pull-right"
              [disabled]="!paymentEntry.form.valid">
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
